import { create } from 'zustand';

export interface SiteFilterObject {
	filter_date: { flagged: boolean; startDate: Date | null; endDate: Date | null };
	source_of_site_lead_c: string;
	type_of_work_c: string;
	project_type_c: string;
	sub_classification_c: string;
	current_stage_of_site_c: string;
	type_of_record_c: string;
}

export type SiteDateSortValue = 'new_to_old' | 'old_to_new' | '';
export type SitePotentialSortValue = 'high_to_low' | 'low_to_high' | '';

export type SiteSortValue = {
	dateSort: SiteDateSortValue;
	potentialSort: SitePotentialSortValue;
};

const initialSiteFilterObject: SiteFilterObject = {
	filter_date: { flagged: false, startDate: null, endDate: null },
	source_of_site_lead_c: '',
	type_of_work_c: '',
	project_type_c: '',
	sub_classification_c: '',
	current_stage_of_site_c: '',
	type_of_record_c: '',
};

interface SiteFilterStore {
	siteFilterObject: SiteFilterObject;
	search: string;
	sortValue: SiteSortValue;
	updateSiteFilterObject: (filter: SiteFilterObject) => void;
	updateSiteSearch: (search: string) => void;
	updateSiteSortValue: (sortValue: SiteSortValue) => void;
	resetSiteFilterStore: () => void;
}

export const useSiteFilterStore = create<SiteFilterStore>((set) => ({
	siteFilterObject: { ...initialSiteFilterObject },
	search: '',
	sortValue: { dateSort: '', potentialSort: '' },
	updateSiteFilterObject: (siteFilterObject): void => set(() => ({ siteFilterObject: { ...siteFilterObject } })),
	updateSiteSearch: (search): void => set(() => ({ search })),
	updateSiteSortValue: (sortValue): void => set(() => ({ sortValue })),
	resetSiteFilterStore: (): void =>
		set(() => ({
			siteFilterObject: { ...initialSiteFilterObject },
			search: '',
			sortValue: { dateSort: '', potentialSort: '' },
		})),
}));
